import { Box } from "@mui/material";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import React, { useEffect, useState } from "react";
import "rsuite/DateRangePicker/styles/index.css";
import "rsuite/Dropdown/styles/index.css";

import "../Settings/SettingsNavigation/Report/Report.css";
import { useDispatch, useSelector } from "react-redux";
import { messages } from "../common/notification";

import { Button, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import Select from "react-select";
import { fetchHouseDetails } from "../redux/action/house";
import { pages } from "../../ApiRoute";
import { fetchMutipleHouseConnectedDevices } from "../Settings/SettingsNavigation/DeviceStatus/function";
import { useNavigate } from "react-router-dom";
import { controlMegaController, getMegaController } from "./functions";
import { updateHouse } from "../redux/action/CollectiveHouse";
import Loading from "../common/Loading";
import { es } from "date-fns/locale";
import { set } from "date-fns";


function MegaController() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const unitReport = useSelector((state) => state.unitReport);
  const housesList = useSelector((state) => state.housesList);
  const mutipleHouse = useSelector((state) => state.mutipleHouse);
  const loginDetails = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);

  const [selectedHouse, setSelectedHouse] = useState([
    {
        "value": "671facea24ddad42817c872a",
        "label": "Aliste Head Office"
    }
]);
  const [megaControllers, setMegaControllers] = useState([]);
  const [connectedids, setConnectedIds] = useState([]);
 
  function toTenDigitBinary(num) {
    const binary = num.toString(2); // Convert to binary
    return binary.padStart(10, "0"); // Pad with zeros to make it 10 digits
  }
  useEffect(() => {
    let totalEnergy = [];
    if (Object.keys(mutipleHouse).length > 0 && selectedHouse.length > 0) {
      for (let house of selectedHouse) {
        if (mutipleHouse[house.value] === undefined) continue;
        let houseData = mutipleHouse[house.value];
        if (houseData.rooms.length > 0) {
          for (let room of houseData.rooms) {
            if (room.megaControllers.length > 0) {
              for (let device of room.megaControllers) {
                let stateBinary = toTenDigitBinary(device?.applianceState?.state || 0);

                let count = 0;
                for (let appliance of device.appliances) {
                  totalEnergy.push({
                    roomName: room.roomName,
                    deviceId: device.deviceId,
                    houseName: houseData.houseName,
                    houseId: houseData._id,
                    roomId: room._id,
                    ...appliance,
                    stateAppliance: Number(stateBinary[count]),
                    stateBinary,
                    index: count,
                  });
                  count++;
                }
              }
            }
          }
        }
      }
    }
    if (selectedHouse.length > 0) {
      fetchMutipleHouseConnectedDevices({
        houseIds: selectedHouse.map((e) => e.value),
      }).then((res) => {
        setConnectedIds(res.map((e) => e.deviceId));
      });
    }
    setMegaControllers(totalEnergy);
  }, [mutipleHouse, selectedHouse]);

  // Handler to toggle select all
  const handleChange = (selected) => {
    let options = housesList.map((e) => {
      return {
        value: e.houseAccessCode,
        label: e.houseName,
      };
    });

    // Check if "Select All" option was clicked
    if (selected && selected.some((option) => option.value === "select_all")) {
      // Select All functionality
      setSelectedHouse(
        selected.length === options.length + 1 ? [] : [...options]
      );
    } else {
      setSelectedHouse(selected);
    }
  };
  const mobileWithoutCountryCode = loginDetails?.profile?.mobile.slice(3);
  useEffect(() => {
    for (let i of selectedHouse) {
      fetchHouseDetails(
        i.value,
        mobileWithoutCountryCode,
        pages.megaControllerPage
      );
    }
  }, [selectedHouse]);
  return (
    <Box>
     {loading && <Loading/>}
      <Box className="d-flex text-start align-items-end gap-5">
        <Box sx={{ minWidth: "200px" }}>
          <DemoItem className="text-start">Property</DemoItem>
          <Select
            className="react-select-container-house-report"
            classNamePrefix="react-select-house-report"
            style={{ width: "100% !important" }}
            options={[
              { value: "select_all", label: "Select All" },
              ...housesList.map((e) => {
                return {
                  value: e.houseAccessCode,
                  label: e.houseName,
                };
              }),
            ]}
            closeMenuOnSelect={false}
            isMulti
            value={selectedHouse}
            onChange={(data) => {
              handleChange(data);
            }}
          />
        </Box>
      </Box>

      <Table striped bordered hover className="mt-3">
        <thead>
          <tr>
            <th>#</th>
            <th>Device Id</th>
            <th>Appliance Name</th>
            <th>Current Status</th>
            <th>Connectivity Status</th>
            <th>View Graph</th>
          </tr>
        </thead>
        <tbody>
          {megaControllers.map((id, index) => {
            return (
              <tr key={`${id.device}-${index}`}>
                <td>{index + 1}</td>
                <td className="text-center vertical-align">{id?.deviceId}</td>
                <td className="text-center vertical-align">{id?.name}</td>
                <td
                  className="text-center vertical-align font-weight-bold"
                  style={{ fontSize: "18px" }}
                >
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="button-tooltip-2">
                        {`Click to ${id?.stateAppliance === 0 ?" Turn ON" : "Turn OFF"}`}
                      </Tooltip>
                    }
                  >
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={async () => {
                        setLoading(true);
                        await controlMegaController(id).then((res) => {
                          if (res.success) {
                            setMegaControllers((prv) => {
                              let newState = prv.map((e) => {
                                if (id.index === e.index && id.deviceId === e.deviceId) {
                                  return {
                                    ...e,
                                    stateBinary: res.applianceState,
                                    stateAppliance: res.currentState,
                                  };
                                } else if(id.index != e.index && id.deviceId === e.deviceId) {
                                  return {
                                    ...e,
                                    stateBinary: res.applianceState,
                                  };
                                } else{
                                  return e;
                                }
                              });
                              return newState;
                            });
                          setTimeout(async()=>{
                           await getMegaController([id.deviceId]).then((res) => {
                             if(res.success){
                              dispatch(updateHouse(id.houseId,id.roomId,res.data.devices))
                             }
                             setLoading(false)
                           })
                          },5000)
                          }else{
                            setLoading(false)
                          }
                        });
                      }}
                    >
                      {id?.stateAppliance === 0 ? (
                        <span style={{ color: "rgb(239 68 68)" }}>Off</span>
                      ) : id?.stateAppliance === 1 ? (
                        <span style={{ color: "rgb(34 197 94)" }}>ON</span>
                      ) : (
                        "-"
                      )}
                    </div>
                  </OverlayTrigger>
                </td>
                <td
                  className="text-center vertical-align"
                  style={{ fontSize: "18px" }}
                >
                  {connectedids.includes(id.deviceId) ? (
                    <span style={{ color: "rgb(34 197 94)" }}>Connected</span>
                  ) : (
                    <span style={{ color: "rgb(239 68 68)" }}>
                      Disconnected
                    </span>
                  )}
                </td>
                <td className="text-center vertical-align">
                {
                  id.meterId!== undefined && id.meterId!==""&& (
               <button
                    className="btn btn-primary"
                    onClick={() => {
                      fetchHouseDetails(
                        id.houseId,
                        mobileWithoutCountryCode,
                        pages.megaControllerPage
                      );
                      navigate(
                        `/dashboard/energySync/${id?.houseId}/${id?.roomId}/${id?.meterId}`
                      );
                    }}
                  >
                    View Graph
                  </button>
                  )
          }
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      <Box className="mt-5" style={{ height: "20px" }}></Box>
    </Box>
  );
}

export default MegaController;
